import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityFeed = () => {
  const activities = [
    {
      id: 1,
      type: 'cv_uploaded',
      title: 'New CV Uploaded',
      description: 'Sarah Johnson - Software Engineer position',
      timestamp: new Date(Date.now() - 300000),
      icon: 'Upload',
      color: 'text-primary'
    },
    {
      id: 2,
      type: 'ai_screening',
      title: 'AI Screening Completed',
      description: 'Michael Chen - 85% match for Data Analyst role',
      timestamp: new Date(Date.now() - 900000),
      icon: 'Brain',
      color: 'text-success'
    },
    {
      id: 3,
      type: 'interview_scheduled',
      title: 'Interview Scheduled',
      description: 'Emma Davis - Tomorrow at 2:00 PM',
      timestamp: new Date(Date.now() - 1800000),
      icon: 'Calendar',
      color: 'text-secondary'
    },
    {
      id: 4,
      type: 'candidate_approved',
      title: 'Candidate Approved',
      description: 'Alex Rodriguez moved to final round',
      timestamp: new Date(Date.now() - 3600000),
      icon: 'CheckCircle',
      color: 'text-success'
    },
    {
      id: 5,
      type: 'job_posted',
      title: 'Job Posting Created',
      description: 'Senior Frontend Developer - React/TypeScript',
      timestamp: new Date(Date.now() - 7200000),
      icon: 'Briefcase',
      color: 'text-warning'
    },
    {
      id: 6,
      type: 'bulk_processing',
      title: 'Bulk CV Processing',
      description: '15 CVs processed for Marketing Manager role',
      timestamp: new Date(Date.now() - 10800000),
      icon: 'Layers',
      color: 'text-primary'
    }
  ];

  const formatTimeAgo = (timestamp) => {
    const now = new Date();
    const diff = now - timestamp;
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    
    if (minutes < 60) {
      return `${minutes}m ago`;
    } else if (hours < 24) {
      return `${hours}h ago`;
    } else {
      return timestamp?.toLocaleDateString();
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 card-elevation-base">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">Recent Activity</h3>
        <div className="flex items-center space-x-2">
          <div className="w-2 h-2 bg-success rounded-full animate-pulse"></div>
          <span className="text-xs text-muted-foreground">Live</span>
        </div>
      </div>
      <div className="space-y-4 max-h-96 overflow-y-auto">
        {activities?.map((activity) => (
          <div key={activity?.id} className="flex items-start space-x-3 p-3 rounded-lg hover:bg-muted/50 transition-colors">
            <div className={`w-8 h-8 rounded-full bg-muted flex items-center justify-center flex-shrink-0 ${activity?.color}`}>
              <Icon name={activity?.icon} size={16} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-foreground">{activity?.title}</p>
              <p className="text-xs text-muted-foreground mt-1">{activity?.description}</p>
              <p className="text-xs text-muted-foreground mt-1">{formatTimeAgo(activity?.timestamp)}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 pt-4 border-t border-border">
        <button className="w-full text-sm text-primary hover:text-primary/80 font-medium transition-colors">
          View All Activity
        </button>
      </div>
    </div>
  );
};

export default ActivityFeed;